import { useState, useRef } from 'react';
import Gallery from '../Gallery/Gallery.js';
import Button from '../Button/Button.js';
import FlexPair from '../FlexPair/FlexPair.js';
import { IMAGE_TEXT_GAP, MOBILE_IMAGE_TEXT_GAP } from '../../utils/Constants.js';

const BaseMystery = ({titleText, imagesList, scriptureQuote, scriptureCitation, citationLink, rightHanded}) => {
	// The double render from <React.StrictMode> can cause images to fail in dev with lots of loads
	const imageIndexRef = useRef(null); // Track image index across renders

	// Pre-loading images in memory
	const preloadImage = (imageUrl) => {
		const img = new Image();
		img.src = imageUrl;

		img.onload = () => {};
		img.onerror = () => {
			console.error("Failed to load", titleText+":", imageUrl);
		};
	}
	const pickFirstRandom = (array) => {
		if (imageIndexRef.current !== null) { return; }
		imageIndexRef.current = Math.floor(Math.random() * array.length);
		const initImage = array[imageIndexRef.current];
		preloadImage(initImage);
		return initImage;
	}
	const pickNextRandom = (array) => {
		let nextImageIndex;

		do { // Make sure to get a NEW index!
			nextImageIndex = Math.floor(Math.random() * array.length);
		} while (nextImageIndex === imageIndexRef.current);
		// This new index is becoming the current one
		imageIndexRef.current = nextImageIndex;

		return array[imageIndexRef.current];
	};

	// Image state machine
	const [currentImageInfos, setCurrentImageInfos] = useState([{
		width: 1,
		height: 1,
		image: <img src={pickFirstRandom(imagesList)} alt={titleText} />
	}]);
	const setCurrentImageInfosHelper = (sourceArg) => {
		setCurrentImageInfos([{
			width: 1,
			height: 1,
			image: <img src={sourceArg} alt={titleText} />
		}]);
	};

	// Button controls
	const randomizeImage = () => {
		setCurrentImageInfosHelper(pickNextRandom(imagesList));
	};
	const swapImageLeft = () => {
		imageIndexRef.current = imageIndexRef.current - 1;
		if (imageIndexRef.current < 0) {
			imageIndexRef.current = imagesList.length - 1;
		}
		setCurrentImageInfosHelper(imagesList[imageIndexRef.current]);
	};
	const swapImageRight = () => {
		imageIndexRef.current = imageIndexRef.current + 1;
		if (imageIndexRef.current >= imagesList.length) {
			imageIndexRef.current = 0;
		}
		setCurrentImageInfosHelper(imagesList[imageIndexRef.current]);
	};

	// FlexPair snippets
	const galleryContent = (
		<Gallery imageInfos={currentImageInfos} />
	);
	const textContent = (
		<div>
			<h3>{titleText}</h3>
			<figure>
				<blockquote>
					<p>{scriptureQuote}</p>
				</blockquote>
				<figcaption>
					<cite><a href={citationLink} rel="noreferrer" target="_blank">{scriptureCitation}</a></cite>
				</figcaption>
			</figure>
			{imagesList.length > 1 && (
				<div style={{marginTop: "20px", display: "flex", gap: "6px", justifyContent: "center"}}>
					<Button onClick={swapImageLeft}>&lt;</Button>
					<Button onClick={randomizeImage}>Randomize</Button>
					<Button onClick={swapImageRight}>&gt;</Button>
				</div>
			)}
		</div>
	);

	if (rightHanded) {
		return (<FlexPair rightContent={galleryContent} leftContent={textContent} pcGap={IMAGE_TEXT_GAP} mobileGap={MOBILE_IMAGE_TEXT_GAP} rightPrecedent={true} />)
	} else {
		return (<FlexPair rightContent={textContent} leftContent={galleryContent} pcGap={IMAGE_TEXT_GAP} mobileGap={MOBILE_IMAGE_TEXT_GAP} rightPrecedent={false} />)
	}
};

export default BaseMystery;